import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Stack } from "@mui/material";
import bg_banner from "../../../assets/images/bg_recruitment_detail.webp";
import { getAllRecruitment, getRecruitmentById } from "../../../api/recruiment";
import RecruitmentDetailContent from "../recruitment-detail-content";
import RecruitmentItem from "../recruitment-item";
import RecruitmentDetailInfoSidebar from "../recruitment-detail-sidebar-info";
import ButtonShare from "../components/button-share";
import RecruitmentApplyModal from "../recruitment-apply-modal";

const Banner = ({ title }) => (
  <div
    className="h-[220px]  relative object-contain"
    style={{
      background: `linear-gradient(90deg, rgba(39, 198, 255, 0.90) 0%, rgba(19, 117, 183, 0.90) 100%), url(${bg_banner})`,
      backgroundColor: "lightgray",
      backgroundPosition: "0px -255.567px",
      backgroundSize: "100% 337.18%",
      backgroundRepeat: "no-repeat",
    }}
  >
    <div className="container px-4 max-w-7xl mx-auto absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
      <p className="text-[24px] md:text-[28px] text-white font-semibold my-2">
        {title}
      </p>
      <div className="px-4 py-2 bg-white rounded-[40px] self-start inline-flex gap-3 items-center">
        <Link to="/">
          <img src="/assets/icons/ic_home.svg" className="w-[22px] h-[22px]" />
        </Link>
        <img
          src="/assets/icons/ic_arrow_right.svg"
          className="w-[22px] h-[22px]"
        />
        <Link to="/recruitment" className="text-[#1375B7]">
          Tuyển dụng
        </Link>
        <img
          src="/assets/icons/ic_arrow_right.svg"
          className="w-[22px] h-[22px]"
        />
        <p className="text-[#1375B7]">Chi tiết công việc</p>
      </div>
    </div>
  </div>
);

export default function RecruitmentDetail() {
  const { id } = useParams();

  const [recruitment, setRecruitment] = useState({});
  const [recruitmentsOther, setRecruitmentsOther] = useState([]);
  const [openModal, setOpenModal] = useState(false);

  // const currentTime = useMemo(() => new Date(), []);

  useEffect(() => {
    if (!id) return;
    const fetchData = async () => {
      const { code, data } = await getRecruitmentById(id);
      if (code === 1) setRecruitment(data);
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    if (!id) return;
    const fetchResults = async () => {
      const { code, data } = await getAllRecruitment();
      if (code === 1)
        setRecruitmentsOther(data.filter((item) => item.id.toString() !== id));
    };
    fetchResults();
  }, [id]);

  const ButtonRecruit = (flex) => (
    <Button
      variant="contained"
      sx={{
        bgcolor: "#27C6FF",
        height: 44,
        "&:hover": {
          bgcolor: "#037CCF",
          opacity: "0.9",
        },
        borderRadius: 30,
        padding: "10px 16px",
        flex,
        textTransform: "none",
        minWidth: 150,
      }}
      onClick={() => setOpenModal(true)}
    >
      Ứng tuyển
    </Button>
  );

  const renderContent = () => (
    <>
      <div className="rounded px-3 py-[6px] inline-flex bg-[#27C6FF] mb-4">
        <p className="text-[18px] font-semibold text-white">
          Chi tiết tin tuyển dụng
        </p>
      </div>
      <RecruitmentDetailContent shareUrl={recruitment.shareUrl} />
      <Stack direction="row" columnGap={2}>
        <ButtonRecruit />
        <ButtonShare vertical={-220} horizontal="left" />
      </Stack>
    </>
  );

  return (
    <div className="lg:pt-[120px] pt-[72px] w-full">
      <Banner title={recruitment.title} />

      <div className="container px-4 sm:max-w-7xl mx-auto py-9">
        <div className="grid grid-cols-12 md:gap-9">
          <div className="hidden md:block col-span-12 md:col-span-8">
            {renderContent()}
          </div>
          <div className="col-span-12 md:col-span-4">
            <RecruitmentDetailInfoSidebar
              recruitment={recruitment}
              groupButton={
                <Stack
                  direction="row"
                  columnGap={2}
                  mt={2}
                  justifyContent="space-between"
                >
                  <ButtonRecruit />
                  <ButtonShare vertical={-190} horizontal="left" />
                </Stack>
              }
            />

            <div className="block md:hidden mt-4">{renderContent()}</div>

            <div className="mt-[30px]">
              <div className="rounded px-3 py-[6px] inline-flex bg-[#27C6FF] mb-4">
                <p className="text-white">Các vị trí khác</p>
              </div>
              <div className="flex flex-col gap-y-4">
                {recruitmentsOther.slice(0, 3).map((item) => (
                  <RecruitmentItem
                    key={item.id}
                    item={item}
                    showImage={false}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {openModal && (
        <RecruitmentApplyModal
          openModal={openModal}
          onClose={() => setOpenModal(false)}
          recruitment={recruitment}
        />
      )}
    </div>
  );
}
